<template>
  <v-container
    fluid
  >
    <basic-123-stepper :step="3" />

    <app-api-call
      class="ma-0 pa-0 pb-0 mt-4"
      :call-result="callResult"
    />

    <ResolveCaseWrapper
      v-if="callResult.finished && callResult.authorized && caseStatusMatches"
    />
  </v-container>
</template>

<script>
import ResolveCaseWrapper from '@/components/investigation/resolveCase/ResolveCaseWrapper.vue'

export default {
  name: 'ResolveCase',
  components: {
    ResolveCaseWrapper
  },
  data () {
    return {
      callResult: { finished: false, authorized: false, error: null, info: null },
      caseStatusMatches: true,
      loading: true
    }
  },
  computed: {
    currentCase () {
      return this.$store.getters.getCurrentCase
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.callResult.finished = false
      this.callResult.error = null
      this.callResult.info = this.$i18n.t('$l.info.checkingRights')
      this.$xapi.get('case/caseId/' + this.$route.params.caseId)
        .then(r => {
          this.$store.commit('SET_CURRENT_CASE', r.data)
          this.callResult.authorized = true
          if (!(this.currentCase.status === 'CLOSED' || this.currentCase.status === 'FIN')) {
            this.caseStatusMatches = false
            this.callResult.info = this.$i18n.t('$l.error.notEligibleToResolve')
          }
        })
        .catch(e => {
          this.callResult.error = e.response.localizedMessage
        })
        .finally(() => {
          this.callResult.finished = true
          this.callResult.info = null
        })
    }
  }
}
</script>
